<template>
	<router-link  :to="{ name: routeName }" :exact="exact">
		<i :class="icon" v-if="!materialIcon"></i>
		<i :class="{ 'material-icons': true, squaredMaterial }" v-else>{{ icon }}</i>
		<span>{{ title }}</span>
	</router-link>
</template>

<script>
export default {
	name: 'BoxMenuMain',
	props: {
		icon: String,
		routeName: String,
		title: String,
		exact: {
			type: Boolean,
			default: false
		},
		materialIcon: {
			type: Boolean,
			default: false
		},
		squaredMaterial: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
a {
	display: flex;
	width: 90%;
	border-radius: 10px;
	text-decoration: none;
	color: #1A2738;
	transition: 0.3s;
	align-items: center;
	padding: 5px 10px;
	margin-top: 5px;

	&:hover, &.active, &.exact-active {
		background-color: #D0F500;

		.material-icons.squaredMaterial {
			color: #D0F500;
		}
	}

	i {
		margin-right: 10px;
		font-size: 2em;
		width: 50px;

		&.material-icons {
			font-size: 23px;

			&.squaredMaterial {
				display: grid;
				align-items: center;
				width: 32px;
				height: 32px;
				margin: 0 18px 0 9px;
				border-radius: $border-radius;
				background-color: #1A2738;
				color: #F3F7FC;
			}
		}
	}

	span {
		font-weight: $font-weight-default-bolder;
		font-size: 1.125em;
	}

}
</style>
